import { render, staticRenderFns } from "./BasicEmpInfo.vue?vue&type=template&id=15ca52a3"
import script from "./BasicEmpInfo.vue?vue&type=script&lang=js"
export * from "./BasicEmpInfo.vue?vue&type=script&lang=js"
import style0 from "./BasicEmpInfo.vue?vue&type=style&index=0&id=15ca52a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports